export const parseOneTrust = (consent: string): any => {
  if (!consent || consent === '') return {}
  try {
    return consent.split('&').reduce((acc, item) => {
      const [key, value] = item.split('=')
      acc[key] = value
      return acc
    }, {})
  } catch (error) {
    console.info('Error parsing OneTrust cookie:', error)
    return {}
  }
}

export const parseOneTrustGroups = (consent: string): any => {
  try {
    return parseOneTrust(consent)
      .groups.split(',')
      .map((group: string) =>
        group.split(':')[1] === '1' ? group[0] : undefined
      )
      .filter(Boolean)
  } catch (error) {
    console.info('Error parsing OneTrust groups:', consent, error)
    return []
  }
}

export const parseOneTrustConsentId = (consent: string): string | undefined =>
  parseOneTrust(consent).consentId
